import { render, staticRenderFns } from "./canal.vue?vue&type=template&id=42ccccfe&scoped=true"
import script from "./canal.vue?vue&type=script&lang=js"
export * from "./canal.vue?vue&type=script&lang=js"
import style0 from "./canal.vue?vue&type=style&index=0&id=42ccccfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ccccfe",
  null
  
)

export default component.exports